var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMycheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.997396,
    y: 0.666669,
    width: 12.6667,
    height: 12.6667,
    rx: 6.33333,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.441 4.66667L6.16319 8.94445L4.21875 7.00001",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.997396,
    y: 0.666669,
    width: 12.6667,
    height: 12.6667,
    rx: 6.33333,
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMycheck);
export default __webpack_public_path__ + "static/media/mycheck.b106022ec9eb24cc623a27c8a981e3b7.svg";
export { ForwardRef as ReactComponent };